(function () {
  'use strict';
  var app = window.Patirti = window.Patirti || {};
  var config = window.PATIRTI_SP || {};
  var strings = (window.PatirtiConfig || {}).strings || {};
  var selector = '[data-sp-card][data-product-id], [data-sp-pdp][data-product-id], [data-sp-cart][data-product-id]';
  var cacheKey = 'patirti_sp_counts';
  var cache = {};
  var active = null;
  var retryTimer = null;
  var scanTimer = null;
  var pending = false;
  var recentViews = {};
  var recentAtc = {};
  var ttl = 60000;
  var anonymousId;

  function storageRead(storage, key) {
    try { return window[storage].getItem(key); } catch (_) { return null; }
  }
  function storageWrite(storage, key, value) {
    try { window[storage].setItem(key, value); } catch (_) { /* Storage can be disabled. */ }
  }
  function productId(value) {
    var id = String(value || '');
    return /^\d+$/.test(id) ? id : '';
  }
  /* Düşük sayılar güven azaltır: tema ayarındaki alt sınırın altındaki ölçüler gösterilmez. */
  function minFor(key) {
    var min = (window.PATIRTI_SP && window.PATIRTI_SP.min) || {};
    var value = Number(min[key]);
    return Number.isFinite(value) && value > 0 ? value : 1;
  }
  function count(value) {
    var number = Number(value);
    return Number.isSafeInteger(number) && number >= 0 ? number : 0;
  }
  function formatCount(value) {
    return value >= 1000
      ? (value / 1000).toLocaleString('tr-TR', { maximumFractionDigits: 1 }) + 'B'
      : value.toLocaleString('tr-TR');
  }
  function template(type) {
    return {
      s: strings.spSold || 'Son 24 saatte {{ count }} adet satıldı!',
      c: strings.spCart || 'Son 12 saatte {{ count }} kişi sepete ekledi!',
      v: strings.spViewed || 'Son 1 saatte {{ count }} kişi inceledi!'
    }[type];
  }
  function textFor(copy, value) {
    return copy.replace(/\{\{\s*count\s*\}\}|__COUNT__/g, formatCount(value));
  }
  function metricsFor(data) {
    return ['s', 'c', 'v'].filter(function (key) { return data[key] > 0 && data[key] >= minFor(key); }).map(function (key) {
      return { type: key, count: data[key], text: textFor(template(key), data[key]), windowHours: { s: 24, c: 12, v: 1 }[key] };
    });
  }
  function contentNode(element) {
    var content = element.querySelector('[data-sp-content]');
    if (!content) {
      content = document.createElement('span');
      content.setAttribute('data-sp-content', '');
      element.appendChild(content);
    }
    return content;
  }
  function setCopy(element, copy, value) {
    var target = contentNode(element);
    var pieces = copy.split(/\{\{\s*count\s*\}\}/);
    target.textContent = '';
    pieces.forEach(function (piece, index) {
      if (index) {
        var strong = document.createElement('strong');
        strong.textContent = formatCount(value);
        target.appendChild(strong);
      }
      target.appendChild(document.createTextNode(piece));
    });
  }
  function renderElement(element, data) {
    var metrics = metricsFor(data);
    var signature = [data.s, data.c, data.v].join(':');
    if (element.dataset.spSignature === signature) return;
    element.dataset.spSignature = signature;
    if (element.hasAttribute('data-sp-pdp')) {
      element.dataset.spS = String(data.s);
      element.dataset.spC = String(data.c);
      element.dataset.spV = String(data.v);
      element.dataset.spMetrics = JSON.stringify(metrics);
      element.hidden = !metrics.length;
      if (metrics.length) setCopy(element, template(metrics[0].type), metrics[0].count);
      else contentNode(element).textContent = '';
      element.dispatchEvent(new CustomEvent('sp:ready', {
        bubbles: true,
        detail: { productId: element.dataset.productId, counts: { s: data.s, c: data.c, v: data.v }, metrics: metrics }
      }));
      return;
    }
    if (element.hasAttribute('data-sp-cart')) {
      var soldEnough = data.s > 0 && data.s >= minFor('s');
      element.hidden = !soldEnough;
      element.classList.add('sp-cart-pill');
      if (soldEnough) {
        setCopy(element, strings.spCartSold || '{{ count }} tanesi satıldı', data.s);
        element.title = textFor(template('s'), data.s);
        element.setAttribute('aria-label', element.title);
      } else {
        contentNode(element).textContent = '';
        element.removeAttribute('title');
        element.removeAttribute('aria-label');
      }
      return;
    }
    element.hidden = !metrics.length;
    if (metrics.length) {
      element.dataset.spType = metrics[0].type;
      renderTicker(element, metrics);
    } else {
      contentNode(element).textContent = '';
      delete element.dataset.spType;
      untrack(element);
    }
  }
  /* Card ticker: every real, non-zero metric (s > c > v) rotates vertically every 3.5 s.
     Only cards on screen tick; a single metric never rotates. */
  var tickers = new Set();
  var visible = new Set();
  var tickTimer = null;
  var viewport = null;
  function iconFor(element, type) {
    var scope = element.closest('[data-product-card], [data-qv-root]') || document;
    var holder = scope.querySelector('template[data-sp-icons]') || document.querySelector('template[data-sp-icons]');
    var icon = holder && holder.content.querySelector('[data-sp-icon="' + type + '"] svg');
    return icon ? icon.cloneNode(true) : null;
  }
  function tickerItem(element, metric) {
    var item = document.createElement('span');
    item.className = 'sp-ticker__item';
    item.dataset.spType = metric.type;
    var icon = iconFor(element, metric.type);
    if (icon) item.appendChild(icon);
    template(metric.type).split(/\{\{\s*count\s*\}\}|__COUNT__/).forEach(function (piece, index) {
      if (index) {
        var strong = document.createElement('strong');
        strong.textContent = formatCount(metric.count);
        item.appendChild(strong);
      }
      if (piece) item.appendChild(document.createTextNode(piece));
    });
    return item;
  }
  function renderTicker(element, metrics) {
    var content = contentNode(element);
    content.className = 'sp-ticker';
    content.textContent = '';
    metrics.forEach(function (metric, index) {
      var item = tickerItem(element, metric);
      if (index) item.setAttribute('aria-hidden', 'true');
      else item.classList.add('is-active');
      content.appendChild(item);
    });
    element.dataset.spIndex = '0';
    if (metrics.length > 1) track(element);
    else untrack(element);
  }
  function syncTimer() {
    var run = visible.size > 0 && document.visibilityState !== 'hidden';
    if (run && !tickTimer) tickTimer = window.setInterval(step, 3500);
    else if (!run && tickTimer) { window.clearInterval(tickTimer); tickTimer = null; }
  }
  function track(element) {
    if (tickers.has(element)) return;
    tickers.add(element);
    if (!('IntersectionObserver' in window)) { visible.add(element); syncTimer(); return; }
    if (!viewport) {
      viewport = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.target.isConnected) { untrack(entry.target); return; }
          if (entry.isIntersecting && tickers.has(entry.target)) visible.add(entry.target);
          else visible.delete(entry.target);
        });
        syncTimer();
      }, { threshold: 0.5 });
    }
    viewport.observe(element);
  }
  function untrack(element) {
    if (!tickers.has(element)) return;
    tickers.delete(element);
    visible.delete(element);
    if (viewport) viewport.unobserve(element);
    syncTimer();
  }
  function advance(element) {
    var items = element.querySelectorAll('.sp-ticker__item');
    if (items.length < 2) return;
    var index = (Number(element.dataset.spIndex) || 0) % items.length;
    var next = (index + 1) % items.length;
    var leaving = items[index];
    leaving.classList.remove('is-active');
    leaving.classList.add('is-leaving');
    leaving.setAttribute('aria-hidden', 'true');
    items[next].classList.remove('is-leaving');
    items[next].classList.add('is-active');
    items[next].removeAttribute('aria-hidden');
    element.dataset.spIndex = String(next);
    element.dataset.spType = items[next].dataset.spType;
    window.setTimeout(function () { leaving.classList.remove('is-leaving'); }, 450);
  }
  function step() {
    visible.forEach(function (element) {
      if (!element.isConnected || element.hidden) { untrack(element); return; }
      advance(element);
    });
  }
  document.addEventListener('visibilitychange', syncTimer);
  function rebind(element, id) {
    if (!element) return;
    var next = productId(id);
    untrack(element);
    delete element.dataset.spSignature;
    delete element.dataset.spType;
    element.hidden = true;
    contentNode(element).textContent = '';
    if (next) element.dataset.productId = next;
    if (config.enabled && config.endpoint) refresh(false);
  }
  function render() {
    document.querySelectorAll(selector).forEach(function (element) {
      var data = cache[productId(element.dataset.productId)];
      if (data) renderElement(element, data);
    });
  }
  function sessionId() {
    if (anonymousId) return anonymousId;
    anonymousId = storageRead('localStorage', 'patirti_sp_sid');
    if (!anonymousId) {
      var bytes = new Uint32Array(2);
      if (window.crypto && window.crypto.getRandomValues) window.crypto.getRandomValues(bytes);
      else { bytes[0] = Math.floor(Math.random() * 4294967296); bytes[1] = Date.now() % 4294967296; }
      anonymousId = Date.now().toString(36) + '-' + bytes[0].toString(36) + bytes[1].toString(36);
      storageWrite('localStorage', 'patirti_sp_sid', anonymousId);
    }
    return anonymousId;
  }
  function logEvent(type, value) {
    var id = productId(value);
    if (!config.enabled || !config.endpoint || !id) return;
    var now = Date.now();
    if (type === 'view') {
      var last = Math.max(Number(storageRead('localStorage', 'patirti_sp_v_' + id)) || 0, recentViews[id] || 0);
      if (last && now - last < 1800000) return;
      recentViews[id] = now;
      storageWrite('localStorage', 'patirti_sp_v_' + id, String(now));
    } else {
      if (recentAtc[id] && now - recentAtc[id] < 5000) return;
      recentAtc[id] = now;
    }
    fetch(config.endpoint, {
      method: 'POST', mode: 'no-cors',
      headers: { 'Content-Type': 'text/plain;charset=utf-8' },
      body: JSON.stringify({ action: 'event', type: type, productId: id, sessionId: sessionId(), ts: now })
    }).catch(function () { /* A failed write never becomes a displayed count. */ });
  }
  function scheduleRetry() {
    if (retryTimer) return;
    retryTimer = window.setTimeout(function () {
      retryTimer = null;
      refresh(false);
    }, 10000);
  }
  function fetchChunk(ids) {
    var controller = new AbortController();
    var timer = window.setTimeout(function () { controller.abort(); }, 20000);
    var url = config.endpoint + (config.endpoint.indexOf('?') === -1 ? '?' : '&') +
      'action=counts&ids=' + encodeURIComponent(ids.join(',')) + '&_tm=' + Date.now();
    return fetch(url, { cache: 'no-store', credentials: 'omit', signal: controller.signal })
      .then(function (response) {
        if (!response.ok) throw new Error('Counts unavailable');
        return response.json();
      }).then(function (response) {
        if (!response || !response.data || typeof response.data !== 'object') return;
        ids.forEach(function (id) {
          var next = response.data[id];
          if (!next || typeof next !== 'object') return;
          var previous = cache[id] || {};
          var normalized = { _at: Date.now() - (response.stale ? ttl - 10000 : 0) };
          ['s', 'c', 'v'].forEach(function (key) {
            var value = count(next[key]);
            normalized[key] = response.stale && !value && previous[key] > 0 ? previous[key] : value;
          });
          cache[id] = normalized;
        });
        storageWrite('sessionStorage', cacheKey, JSON.stringify(cache));
        if (response.stale) scheduleRetry();
      }).catch(function () {
        /* Offline and timed-out requests retain the last verified values. */
      }).finally(function () {
        window.clearTimeout(timer);
        render();
      });
  }
  function refresh(force) {
    if (!config.enabled || !config.endpoint) return Promise.resolve();
    render();
    if (active) { pending = true; return active; }
    var ids = [];
    document.querySelectorAll(selector).forEach(function (element) {
      var id = productId(element.dataset.productId);
      if (id && ids.indexOf(id) < 0 && (force === true || !cache[id] || Date.now() - cache[id]._at >= ttl)) ids.push(id);
      if (element.hasAttribute('data-sp-pdp')) logEvent('view', id);
    });
    if (!ids.length) return Promise.resolve();
    var chunks = [];
    for (var offset = 0; offset < ids.length; offset += 50) chunks.push(ids.slice(offset, offset + 50));
    active = chunks.reduce(function (chain, chunk) {
      return chain.then(function () { return fetchChunk(chunk); });
    }, Promise.resolve()).finally(function () {
      active = null;
      if (pending) { pending = false; refresh(false); }
    });
    return active;
  }
  app.sp = {
    logView: function (id) { logEvent('view', id); },
    logAtc: function (id) { logEvent('atc', id); },
    refresh: refresh,
    rebind: rebind
  };
  function init() {
    if (!config.enabled || !config.endpoint) return;
    try {
      var stored = JSON.parse(storageRead('sessionStorage', cacheKey) || '{}');
      Object.keys(stored).forEach(function (id) {
        var data = stored[id];
        if (productId(id) && data && Number.isFinite(data._at)) cache[id] = { s: count(data.s), c: count(data.c), v: count(data.v), _at: data._at };
      });
    } catch (_) { cache = {}; }
    refresh(false);
    new MutationObserver(function (records) {
      var hasNewProof = records.some(function (record) {
        return Array.from(record.addedNodes).some(function (node) {
          return node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector));
        });
      });
      if (hasNewProof) {
        window.clearTimeout(scanTimer);
        scanTimer = window.setTimeout(function () { refresh(false); }, 50);
      }
    }).observe(document.body, { childList: true, subtree: true });
    document.addEventListener('collection:reloaded', function () { refresh(false); });
    document.addEventListener('shopify:section:load', function () { refresh(false); });
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === 'visible') refresh(false);
    });
    window.addEventListener('pageshow', function (event) { if (event.persisted) refresh(false); });
    window.setInterval(function () {
      if (document.visibilityState !== 'hidden') refresh(false);
    }, ttl);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
